import React from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import useCloseQuestionMutation from '../../mutations/useCloseQuestionMutation';
import useQuestionsQueryParams from '../../hooks/useQuestionsQueryParams';
import { questionsQueryKeys } from '../../queries/questionsQueryKeys';
import { selectedQuestionSelector } from '../../store/selectors';
import { setSelectedQuestion } from '../../store/actions';
import CloseQuestionBtn from '../CloseQuestionBtn/CloseQuestionBtn';
import { fetchQuestionById } from '../../queries/useQuestions';

const RequestToCloseQuestion = () => {
  const queryClient = useQueryClient();

  const dispatch = useDispatch();

  const questionsQueryParams = useQuestionsQueryParams();

  const selectedQuestion = useSelector(selectedQuestionSelector);

  const handleSuccess = async (data) => {
    if (data !== 'Error') {
      queryClient.invalidateQueries(
        questionsQueryKeys.questions(questionsQueryParams)
      );

      const updatedQuestionArr = await fetchQuestionById({
        queryClient,
        questionId: selectedQuestion?.id,
      });

      if (updatedQuestionArr?.length === 1) {
        dispatch(setSelectedQuestion(updatedQuestionArr[0]));
      }
    }
  };

  const { mutate: closeQuestion, isLoading: isCloseQuestionLoading } =
    useCloseQuestionMutation({
      onSuccess: handleSuccess,
    });

  const handleConfirm = () => {
    closeQuestion({ questionId: selectedQuestion.id });
  };

  return (
    <CloseQuestionBtn
      tooltipProps={{
        title: 'Отправить запрос на закрытие',
        placement: 'right',
      }}
      popconfirmTitle="Отправить запрос на закрытие?"
      onConfirm={handleConfirm}
      loading={isCloseQuestionLoading}
    />
  );
};

export default RequestToCloseQuestion;
